import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import Repository from '@/types/repositoryType';
import headerObject from '@/types/headerObj';

const endPoint = 'getRepositoryInfo/';
const url = apiUrl + endPoint;

const getRepositoryInfo = async (
  repository: Repository,
  headerObj: headerObject
) => {
  const options = {
    method: 'POST',
    url: url,
    headers: {
      ...headerObj,
    },
    data: {
      RepoUUID: repository.UUID,
    },
  };
  try {
    const response = await postWithAuth(url, options.data);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    return data.RepoInfo;
  } catch (err) {
    console.error(err);
  }
};

export default getRepositoryInfo;
